import { v4 as uuid } from "uuid";

import type { EventRequest } from "./types";

export enum EventType {
  visit = "visit",
  push_opened = "push_opened",

  // ~_clicked
  friendtalk_button_clicked = "friendtalk_button_clicked",
  alimtalk_button_clicked = "alimtalk_button_clicked",
  landing_clicked = "landing_clicked",
  email_link_clicked = "email_link_clicked",
  sms_link_clicked = "sms_link_clicked",

  product_detail_view = "product_detail_view",
  purchase = "purchase",
  order = "order",
  cartadd = "cartadd",
  like = "like",
  rate = "rate",
  page_visit = "page_visit",
  page_view = "page_view",

  instant_impression = "instant_impression",
  persistent_impression = "persistent_impression",
  search = "search",

  section_view = "section_view",
  click = "click",
}

export abstract class Event {
  public readonly request: EventRequest;
  constructor(data: Omit<EventRequest, "id" | "captured_at">) {
    this.request = {
      id: uuid(),
      captured_at: new Date().toISOString(),
      ...data,
    };
  }
}
